import type { z } from 'zod';
import type { shopSchema } from '../schema.ts';
import { TOWNS } from '../ids.ts';
import { gear } from './gear.ts';

/** Fixed-price NPC sellers. The player market (M5) is where prices float. */
export const shops: z.input<typeof shopSchema>[] = [
  {
    key: 'apothecary', name: 'The Apothecary', icon: 'apothecary', towns: [...TOWNS],
    description: 'Jars of leeches, bundles of herbs and a sour-faced keeper.',
    // Tonics and elixirs for coin: a way to turn spare coin into progress, held back by the draught cooldown.
    stock: [
      { item: 'healing-draught', price: 40 },
      { item: 'vigour-tonic', price: 250 },
      { item: 'elixir-of-clarity', price: 300 },
    ],
  },
  {
    key: 'tavern', name: 'The Tavern', icon: 'tavern-sign', towns: [...TOWNS],
    description: 'A fire, a bench and something to lift the spirits. Mood above your base drifts back down.',
    stock: [
      { item: 'tankard-of-ale', price: 4 },
      { item: 'flagon-of-mead', price: 30 },
    ],
  },
  {
    key: 'chandler', name: 'The Chandler', icon: 'candles', towns: [...TOWNS],
    description: 'Barley, herbs, picks, ingots and timber for the venues, at prices from the Harrowmere market.',
    stock: [
      { item: 'barley', price: 6 },
      { item: 'herbs', price: 12 },
      { item: 'lockpick', price: 5 },
      { item: 'bolt-of-linen', price: 3 },
      { item: 'tanned-hide', price: 12 },
      { item: 'bronze-ingot', price: 8 },
      { item: 'iron-ingot', price: 15 },
      { item: 'steel-ingot', price: 35 },
      { item: 'damascus-ingot', price: 90 },
      { item: 'oak-log', price: 10 },
      { item: 'yew-log', price: 28 },
      { item: 'osmund-ingot', price: 120 },
      { item: 'star-iron-ingot', price: 200 },
      { item: 'ash-log', price: 40 },
      { item: 'elm-log', price: 55 },
    ],
  },
  // Gear at a markup over its value (data/gear.ts): the cheaper metals, woods and armours only.
  {
    key: 'armourer', name: 'The Armourer', icon: 'anvil-impact', towns: ['wynchester', 'ironhold'],
    description: 'Racks of bronze and iron, and quilted coats on pegs. Steel you forge yourself, or buy from someone who did.',
    stock: gear.armourer,
  },
  {
    key: 'bowyer', name: 'The Bowyer', icon: 'bow-arrow', towns: ['wynchester', 'thornwood'],
    description: 'Oak and yew staves drying in the rafters, and sheaves of arrows by the door.',
    stock: gear.bowyer,
  },
];
